import { jobProfileSkillDelete, jobProfileSkillGet } from "#job-profile/services/api"
import JobProfileItem from "../JobProfileItem"
import { JobProfileSkillsFormDialog } from "./JobProfileSkillsForm"
import { TABLE_SKILLS_ITEMS } from "./JobProfileSkillsTable"

export default function JobProfileSkills({ profileId, autoFetch, noEdit }) {
	return (
		<JobProfileItem
			key="skills"
			{...{
				profileId,
				autoFetch,
				tableItems: TABLE_SKILLS_ITEMS,
				apiGet: jobProfileSkillGet,
				apiDelete: jobProfileSkillDelete,
				name: "",
				messageDelete: (competence) => (
					<span>
						¿Está seguro de que desea eliminar la capacidad profesional
						<strong> {competence.name}</strong>?
					</span>
				),
				AddForm: JobProfileSkillsFormDialog,
				noEdit,
			}}
		/>
	)
}
